var map = {
	"./ablakozas-thumb - Copy.jpg": "9516",
	"./ablakozas-thumb.jpg": "9199",
	"./ablakozas.jpg": "8489",
	"./braille-nyomtatas-thumb.jpg": "6f7f",
	"./braille-nyomtatas.jpg": "0e54",
	"./dobozragasztas-thumb.jpg": "4a39",
	"./dobozragasztas.jpg": "49f8",
	"./doboztervezes-thumb.jpg": "eddb",
	"./doboztervezes.jpg": "91f2",
	"./dombornyomas-thumb.jpg": "0eb9",
	"./dombornyomas.jpg": "a477",
	"./iv-ezust-arany-melegfoliazasa-thumb.jpg": "b368",
	"./iv-ezust-arany-melegfoliazasa.jpg": "fede",
	"./ivkasirozas-thumb.jpg": "ad8e",
	"./ivkasirozas.jpg": "d247",
	"./lakkozasi-eljarasok-thumb.jpg": "4310",
	"./lakkozasi-eljarasok.jpg": "b1f3",
	"./melegfoliazas-thumb.jpg": "5adb",
	"./melegfoliazas.jpg": "270a",
	"./nyomtatas-femgozolt-kartonra-thumb.jpg": "8095",
	"./nyomtatas-femgozolt-kartonra.jpg": "6987",
	"./ofszetnyomtatas-thumb.jpg": "21b7",
	"./ofszetnyomtatas.jpg": "9841",
	"./pregeles-fempregeles-thumb.jpg": "c5e8",
	"./pregeles-fempregeles.jpg": "4336",
	"./proof-nyomtatas-mintakeszites-thumb.jpg": "938b",
	"./proof-nyomtatas-mintakeszites.jpg": "3c32",
	"./reklamanyag-gyartas.jpg": "433a",
	"./stancolas-thumb.jpg": "7f90",
	"./stancolas.jpg": "753c",
	"./virtualis-modellezes-thumb.jpg": "3253",
	"./virtualis-modellezes.jpg": "630b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "eeb4";